import React from 'react'
import FileContainer from 'components/FileContainer/FileContainer'

export function FileContainerMock(): React.ReactElement {
  return (
    <div className="flex flex-col gap-2 w-full">
      <FileContainer file={{ name: 'report.pdf' }} href="#" />
      <FileContainer file={{ name: 'image.png' }} handleRemoveFile={() => {}} />
    </div>
  )
}
